import { createSlice } from '@reduxjs/toolkit';
import { RutaSesionTipoEnum } from 'enums/rutaSesionTipo';

interface IModalProgresionDesafio {
	display: boolean;
	type: RutaSesionTipoEnum | undefined;
}

const initialState: IModalProgresionDesafio = { display: false, type: undefined };

const modalProgresionDesafioSlice = createSlice({
	name: 'modalProgresionDesafioState',
	initialState,
	reducers: {
		displayModalProgresion: (state, action) => {
			return { display: true, type: action.payload };
		},
		hideModalProgresion: () => {
			return initialState;
		}
	}
});

export const { displayModalProgresion, hideModalProgresion } = modalProgresionDesafioSlice.actions;

export default modalProgresionDesafioSlice.reducer;
